import { gql } from '@apollo/client';

export const ShowListPhotos = gql`
    query listPhotos($listId:Int!) {
      ShowListPhotos (listId:$listId) {
        id
        listId
        name
        type
        isCover
      }
    }
    `;

export const CreateListPhotosMutation = gql`
    mutation UploadListPhotos ($listId:Int!, $name: String, $type: String) {
      CreateListPhotos (listId:$listId, name: $name, type: $type) {
        status
        photosCount
      }
    } 
    `;

export const RemoveListPhotosMutation = gql`
    mutation RemoveListPhotos($listId:Int!, $name:String) {
      RemoveListPhotos (listId:$listId, name: $name) {
        status
        photosCount
        iscoverPhotoDeleted
      }
    }
    `;

export const userAccountPicture = gql`
    query userAccount($userId: String) {
        userAccount(userId: $userId) {
          picture
  }
}
    `;

export const UploadProfilePicture = gql`
   mutation UploadProfilePicture($picture: String!,$userId:String){
      UploadProfilePicture(picture: $picture,userId:$userId) {
             status
           }
        }
`;

export const RemoveProfilePicture = gql`
    mutation RemoveProfilePicture($userId:String){
       RemoveProfilePicture(userId:$userId) {
             status
           }
          }
    `;